module.exports = __webpack_public_path__ + "static/bombomba-839afe1679a96debac3be4c50fe89a7d.jpg";